'use es6';

import links from 'crm-legacy-links/links';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const TASK_DEPENDENCY_ALERT_TIMEOUT = 6000;
export function showResolveTaskDependencyAlert(taskDependency) {
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks.alerts.resolveTaskDependency.title"
  });
  const options = {
    href: links.specificSequence(taskDependency.getIn(['taskDependencyMetadata', 'sequenceId'])),
    sequenceName: taskDependency.getIn(['taskDependencyMetadata', 'sequenceName'])
  };
  const message = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "tasks.alerts.resolveTaskDependency.message_jsx",
    options: options,
    elements: {
      Link
    }
  });
  FloatingAlertStore.addAlert({
    titleText,
    message,
    type: 'success',
    timeout: TASK_DEPENDENCY_ALERT_TIMEOUT
  });
}
export function showAlreadyResolvedTaskDependencyAlert(taskDependency, status) {
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `tasks.alerts.alreadyResolvedTaskDependency.title.${status}`
  });
  const options = {
    href: links.specificSequence(taskDependency.getIn(['taskDependencyMetadata', 'sequenceId'])),
    sequenceName: taskDependency.getIn(['taskDependencyMetadata', 'sequenceName'])
  };
  const message = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "tasks.alerts.alreadyResolvedTaskDependency.message_jsx",
    options: options,
    elements: {
      Link
    }
  });
  FloatingAlertStore.addAlert({
    titleText,
    message,
    type: 'success',
    timeout: TASK_DEPENDENCY_ALERT_TIMEOUT
  });
}
export function showDeletedPausingTaskAlert(taskDependency) {
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks.alerts.deletedTaskWithDependency.title"
  });
  const options = {
    href: links.specificSequence(taskDependency.getIn(['taskDependencyMetadata', 'sequenceId'])),
    sequenceName: taskDependency.getIn(['taskDependencyMetadata', 'sequenceName'])
  };
  const message = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "tasks.alerts.deletedTaskWithDependency.message_jsx",
    options: options,
    elements: {
      Link
    }
  });
  FloatingAlertStore.addAlert({
    titleText,
    message,
    type: 'success',
    timeout: TASK_DEPENDENCY_ALERT_TIMEOUT
  });
}